import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';

export default function Changelog() {
  const [md, setMd] = useState('');
  useEffect(() => {
    fetch('/CHANGELOG.md')
      .then((res) => res.text())
      .then(setMd);
  }, []);
  return (
    <article className="prose mx-auto">
      <ReactMarkdown>{md}</ReactMarkdown>
    </article>
  );
}
